var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "validation-observer",
    { ref: "conflito", attrs: { tag: "div" } },
    [
      _c(
        "el-card",
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { staticClass: "margin-top", attrs: { md: 6, sm: 12 } },
                [
                  _c("span", { staticClass: "info-title" }, [
                    _vm._v("Número do Processo:")
                  ]),
                  _c("span", { staticClass: "info-label" }, [
                    _vm._v(_vm._s(_vm.conflito.numeroProcesso))
                  ])
                ]
              ),
              _c(
                "el-col",
                { staticClass: "margin-top", attrs: { md: 6, sm: 12 } },
                [
                  _c("span", { staticClass: "info-title" }, [
                    _vm._v("Município:")
                  ]),
                  _c("span", { staticClass: "info-label" }, [
                    _vm._v(
                      _vm._s(
                        _vm.conflito.municipio
                          ? _vm.conflito.municipio.nome
                          : "-"
                      )
                    )
                  ])
                ]
              ),
              _c(
                "el-col",
                { staticClass: "margin-top", attrs: { md: 6, sm: 12 } },
                [
                  _c("span", { staticClass: "info-title" }, [
                    _vm._v("Número de Famílias:")
                  ]),
                  _c("span", { staticClass: "info-label" }, [
                    _vm._v(_vm._s(_vm.conflito.numeroFamilias))
                  ])
                ]
              ),
              _c(
                "el-col",
                { staticClass: "margin-top", attrs: { md: 6, sm: 12 } },
                [
                  _c("span", { staticClass: "info-title" }, [
                    _vm._v("Jurisdição:")
                  ]),
                  _c("span", { staticClass: "info-label" }, [
                    _vm._v(_vm._s(_vm.conflito.jurisdicoFormatada))
                  ])
                ]
              ),
              _c(
                "el-col",
                { staticClass: "margin-top", attrs: { md: 6, sm: 12 } },
                [
                  _c("span", { staticClass: "info-title" }, [
                    _vm._v("Data de Cadastro:")
                  ]),
                  _c("span", { staticClass: "info-label" }, [
                    _vm._v(_vm._s(_vm.conflito.dataCriacaoFormatada))
                  ])
                ]
              ),
              _c(
                "el-col",
                { staticClass: "margin-top", attrs: { md: 6, sm: 12 } },
                [
                  _c("span", { staticClass: "info-title" }, [
                    _vm._v("Origem:")
                  ]),
                  _c("span", { staticClass: "info-label" }, [
                    _vm._v(_vm._s(_vm.conflito.origemFormatada))
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "top-margin" },
        [
          _c(
            "el-row",
            { staticClass: "marginLeft" },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c("app-divider", {
                    attrs: {
                      label: "Área com conflito",
                      showBorder: true,
                      required: "required"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c("validation-provider", {
                    attrs: {
                      mode: "lazy",
                      rules: "required",
                      name: "Área com conflito"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(ref) {
                          var errors = ref.errors
                          return [
                            _c("p", { staticClass: "margin-titulo" }, [
                              _vm._v("Observação")
                            ]),
                            _c("el-input", {
                              staticClass: "input",
                              class: { erro: errors.length },
                              attrs: { type: "textarea", rows: 4 },
                              model: {
                                value: _vm.conflito.observacao,
                                callback: function($$v) {
                                  _vm.$set(_vm.conflito, "observacao", $$v)
                                },
                                expression: "conflito.observacao"
                              }
                            }),
                            _c("span", { staticClass: "help erro" }, [
                              _vm._v(_vm._s(errors[0]))
                            ])
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "app-label",
                    {
                      attrs: {
                        label:
                          "Possui o georreferenciamento do imóvel de acordo com as normas técnicas em vigência?",
                        required: true
                      }
                    },
                    [
                      _c("validation-provider", {
                        attrs: {
                          rules: "required",
                          name: "Possui georreferenciamento"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(ref) {
                              var errors = ref.errors
                              return [
                                _c(
                                  "el-radio-group",
                                  {
                                    staticClass: "input padding",
                                    class: { erro: errors.length },
                                    model: {
                                      value:
                                        _vm.conflito.possuiGeorreferenciamento,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.conflito,
                                          "possuiGeorreferenciamento",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "conflito.possuiGeorreferenciamento"
                                    }
                                  },
                                  [
                                    _c("el-radio", { attrs: { label: true } }, [
                                      _vm._v("Sim")
                                    ]),
                                    _c(
                                      "el-radio",
                                      { attrs: { label: false } },
                                      [_vm._v("Não")]
                                    )
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.conflito.possuiGeorreferenciamento
                ? _c(
                    "el-col",
                    { staticClass: "margin", attrs: { span: 24 } },
                    [
                      _c("app-documentos", {
                        attrs: {
                          aba: "Georreferenciamento",
                          isAnalise: true,
                          idUploadDocumento: "documentoGeorreferenciamento",
                          titulo: "Georreferenciamento",
                          maxSize: 25000,
                          "valid-extensions": _vm.extensoes,
                          documentos: _vm.documentos,
                          tiposDocumentos: _vm.tipoDocumentos,
                          tiposDocumentosObrigatorios:
                            _vm.tipoDocumentosObrigatorios,
                          pecasTecnicas: true,
                          observer: this.$refs.conflito
                        },
                        on: {
                          mudaTipo: _vm.mudaTipo,
                          setDadosPlanilha: _vm.setDadosPlanilha,
                          removedDoc: _vm.removeFile,
                          addedDoc: _vm.addedDoc
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.conflito.possuiGeorreferenciamento === false
                ? _c(
                    "el-col",
                    { staticClass: "margin", attrs: { span: 24 } },
                    [
                      _c("validation-provider", {
                        attrs: { rules: "required", name: "Geometrias" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("mapa-analise-geomensor", {
                                    attrs: {
                                      localizacoes: _vm.conflito.geometrias,
                                      tipoCadastro: "NAO_ONEROSO",
                                      name: "Geometria",
                                      idMapa: "mapaAnaliseGeomensor",
                                      errors: errors,
                                      addPonto: true
                                    },
                                    on: {
                                      shapefileUploaded: _vm.setShapefile,
                                      shapefileRemoved: _vm.removeShapefile
                                    },
                                    model: {
                                      value: _vm.conflito.geometrias,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.conflito,
                                          "geometrias",
                                          $$v
                                        )
                                      },
                                      expression: "conflito.geometrias"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1257684792
                        )
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { staticClass: "flex", attrs: { span: 24 } },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn",
                  attrs: { type: "default", size: "small" },
                  on: { click: _vm.cancelar }
                },
                [
                  _c("span", { staticClass: "center" }, [
                    _c("i", { staticClass: "fa fa-times" }),
                    _c("b", [_vm._v("  Cancelar")])
                  ])
                ]
              ),
              _c(
                "el-button",
                {
                  staticClass: "btn",
                  attrs: { type: "success", size: "small" },
                  on: { click: _vm.salvarCadastro }
                },
                [
                  _c("span", { staticClass: "center" }, [
                    _c("i", { staticClass: "fa fa-share-square" }),
                    _c("b", [_vm._v("  Enviar")])
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bae83872", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bae83872","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/comunicacao/ShapeConflito.vue
// module id = null
// module chunks = 